import React, { useRef, useEffect } from "react";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const AudioPreview = ({ url }) => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current.load();
  }, [url]);

  return (
    <ElementRoot loaded>
      <audio
        ref={ref}
        autoPlay
        controls
      >
        <source src={url} />
      </audio>
    </ElementRoot>
  );
};

AudioPreview.propTypes = mediaElementShape;
